import Model from "./Model";

/**
 * A patient followed by a doctor through the patient channel.
 * Identified by a pseudonymous code only.
 */
export default class Patient extends Model {
  static type = "patients";

  code: string;
  phoneE164: string | null;
  email: string | null;
  timeZone: string;
  consentAt: string;
  consentVersion: string;
  optedOutAt: string | null;
  optOutChannel: string | null;
  databaseId: number;
  userId: number;

  get isOptedOut(): boolean {
    return !!this.optedOutAt;
  }
}
